"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.BannerWithoutGatsbyImage = exports.BannerImage = exports.BannerText = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _Media = _interopRequireDefault(require("../Media"));

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var Wrapper = (0, _styled.default)(_rebass.Box)(function (_ref) {
  var position = _ref.position,
      size = _ref.size;
  var style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: position
  };
  var sizes = {
    small: '4rem',
    regular: '4rem',
    large: '8rem'
  };
  return _objectSpread(_objectSpread({}, style), {}, {
    backgroundColor: 'transparent',
    maxHeight: sizes[size]
  });
});
exports.Wrapper = Wrapper;
var BannerText = (0, _styled.default)('p')(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      banner = _ref2$theme.banner,
      colors = _ref2$theme.colors,
      fonts = _ref2$theme.fonts,
      textSize = _ref2.textSize,
      textColor = _ref2.textColor;
  return _defineProperty({
    marginBottom: 0,
    marginRight: '1rem',
    fontSize: textSize === 'large' ? '1.2rem' : '1.1rem',
    color: textColor === 'light' ? colors[banner.textColorLight] : colors[banner.textColorDark],
    fontFamily: textSize === 'large' ? fonts.heading : fonts.body,
    fontWeight: 'bold'
  }, _mediaQueries.default.medium, {
    fontSize: textSize === 'large' ? '1.6rem' : '1.4rem'
  });
});
exports.BannerText = BannerText;

var imageProps = function imageProps(size, textSize) {
  var sizes = {
    small: '3rem',
    regular: '6rem',
    large: '14rem'
  };

  var sizesDesktop = _objectSpread(_objectSpread({}, sizes), {}, {
    xlarge: '14rem'
  });

  return _defineProperty({
    height: 'auto',
    width: sizes[size],
    display: 'block'
  }, _mediaQueries.default.medium, {
    width: textSize === 'large' ? sizesDesktop.xlarge : sizesDesktop[size]
  });
};

var BannerImage = (0, _styled.default)(_Media.default)(function (_ref5) {
  var size = _ref5.size,
      textSize = _ref5.textSize;
  return imageProps(size, textSize);
});
exports.BannerImage = BannerImage;
var BannerWithoutGatsbyImage = (0, _styled.default)(_rebass.Image)(function (_ref6) {
  var size = _ref6.size,
      textSize = _ref6.textSize;
  return imageProps(size, textSize);
});
exports.BannerWithoutGatsbyImage = BannerWithoutGatsbyImage;